import React from 'react'
import EmptyImg from '../Assets/EmptyImg.png'


export default function EmptyComponent (props) {
    return(
        <div className='flex items-center flex-col justify-center gap-2'>
            <img className='w-[8rem] h-[7rem]' src={EmptyImg} />
            <p className='text-[1.2rem] text-[#111928] font-[600] mt-2'>{props.title}</p>
            <p className='text-[0.90rem] text-[#6B7280] font-[500] text-center'>{props.text}</p>
        </div>
    );
}